module.exports = __webpack_public_path__ + "logo.ba9658c3e9090c8fe639.png";


//////////////////
// WEBPACK FOOTER
// /Users/sooweeseng/Documents/Ionic Apps/FoonYew2_Backend_ok_version/webapp/src/assets/img/logo.png
// module id = ../../../../../src/assets/img/logo.png
// module chunks = styles